import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./features/auth/authSlices";
import categoryReducer from "./features/category/categorySlice";
import productReducer from "./features/product/productSlice";
import vendorReducer from "./features/vendor/vendorSlice";
import orderReducer from "./features/orders/orderSlice";
import contentReducer from "./features/content/contentSlice";
import couponReducer from "./features/coupon/couponSlice";
import dashboardReducer from "./features/dashbaord/dashboardSlice"

const rootReducer = combineReducers({
  auth: authReducer,
  category: categoryReducer,
  product: productReducer,
  vendor: vendorReducer,
  order: orderReducer,
  content: contentReducer,
  coupon: couponReducer,
  dashboard:dashboardReducer,
});

export default rootReducer;
